export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9110.9bf50246.jpg";